import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Pagination } from "antd";
import "@liepin/antd-city-pc/lib/index.less";
import ajax from "../../utils/ajax";
import { filterComps } from "./dataConfig";
import "./index.less";

export default () => {
  const [companyListRes, setCompanyListRes] = useState([]);
  const [next, setNext] = useState(true);
  const [total, setTotal] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [companyList, setCompanyList] = useState([]);

  const splitArray = (groupSize, originArray) => {
    const groups = [];
    for (let i = 0; i < originArray.length; i += groupSize) {
      const group = originArray.slice(i, i + groupSize);
      groups.push(group);
    }
    return groups;
  };

  const getData = (data) => {
    const {
      curPage = 0,
      isInit = false,
    } = data || {};
    if (curPage >= 100) {
      setNext(false);
    }

    if (!next && !isInit) return;
    // 初始化请求，先请求5页的数据， 用于快速点击跳转
    // 服务端接口不再有totalCount值，需要使用next来判断是否有下一页
    const params = {};
    if (isInit) {
      setNext(true);
    }
    const searchConditionVo = {
      "curPage": curPage,
      "pageSize": 20,
      "sortType": '1',
      "searchType": '1',
      "showConditionVo": { "showOnlineTime": false, "tagShowCondition": { "showCompanyScale": true, "showCompanyStage": true, "showCompanyIndustry": false, "showCompanyKind": false, "showWorkYear": false, "showEduLevel": false, "showJobTags": false } },
      "dqCode": ["410"], 
      "industry": [], 
      "jobTitle": [], 
      "keyword": "", 
      "publisherTypes": [], 
      "workYear": [], 
      "eduLevel": [],
      "jobSourceVos":[
        {"jobKind":"2",
        "jobIds":[
          "62394219",
          "64298069",
          "61520455",
          "23819031",
          "53606465",
          "27877547",
          "29221083",
          "60724653",
          "63316769",
          "60040173",
          "60039859",
          "52775551",
          "52775673",
          "64125345",
          "62972439",
          "67024537",
          "67141353",
          "67263879",
          "39071765",
          "52592413",
          "67284669",
          "66270099",
          "69242777",
          "53592973",
          "42761019",
          "34887015",
          "62428689",
          "68333061",
          "69381309",
          "68138001",
          "67904487",
          "67972073",
          "67299659",
          "21487801",
          "63503731",
          "63511623",
          "68404317",
          "62335047",
          "63007027",
          "63590751",
          "60619969",
          "17127333",
          "50766721",
          "67624273",
          "69426521",
          "19987129",
          "69090225",
          "68770657",
          "60633907",
          "54812977",
          "60085103",
          "59204659",
          "61312335",
          "66801017",
          "68208439",
          "35230929",
          "35231083",
          "66584617",
          "21264889",
          "63071127",
          "58058395",
          "69303143",
          "69303139",
          "25199903",
          "38022393",
          "56613641",
          "26212319",
          "68172091",
          "68137199",
          "67188085",
          "68143063",
          "67363911",
          "68933605",
          "49898727",
          "69475779",
          "68108513",
          "64944239",
          "66506815",
          "57574555",
          "69534199",
          "54126949",
          "54546559",
          "63779785",
          "63779715",
          "54943323",
          "61398333",
          "56248163",
          "69387661",
          "69408565",
          "63200341",
          "63201535",
          "48026849",
          "48130973",
          "65799531",
          "64760365",
          "69127917",
          "54282945",
          "50222853",
          "52490187",
          "37987355",
          "37987477",
          "6500496",
          "68774413",
          "68296613",
          "65602049",
          "67666687",
          "69525357",
          "40728653",
          "64158939",
          "40692751",
          "58793853",
          "67905039",
          "67904385",
          "65354629",
          "64479897",
          "68307945",
          "68470471",
          "69558963",
          "69382725",
          "65441951",
          "65443059",
          "55698037",
          "33518265",
          "54363457",
          "54364295",
          "54127567",
          "47474027",
          "67566357",
          "52819153",
          "59735605",
          "51162935",
          "64557849",
          "64557851",
          "68080023",
          "49386635",
          "63912077",
          "64037523",
          "69406237",
          "69471503",
          "21671485","21726437","21823625","22267427","65527917","63801553","69280013","69805889","68279067","67385019","53755225","42360599","60179641","47267731","68399931","69358411","53490245","55255213","68881157","68392891","68747079","55185153","62982143","63709771","56697071","56697099","62971231","66682525","65489075","66084729","54402463","54402625","63705969","57189907","64978751","65146047","57620389","57709355","65016453","65017191","69763941","69762485","68613713","67738225","59387909","55929227","38316827","49906865","45381355","58389135","58390365","61027073","64949857","66311365","69712081","63063007","49438303","68596217","65223667","39386467","35326335","65225777","65220343","46752613","36326535","36668923","48319589","54023421","64162573","67104795","61486271","60784215","64249379","64638697","52187931","28216203","65991125","57178347","26983487","26983033","67811513","65543441","69640685","69638811","26299545","23026787","44379323","53616503","69602231","69602017","69698141","64445415","65460015"
        ]
        }
      ],
    };

    params.searchConditionVo = JSON.stringify(searchConditionVo);

    ajax
      .post(
        "https://api-wanda.liepin.com/api/com.liepin.rivers.newjob.get-search-jobs",
        params
      )
      .then(({ data, traceId }) => {
        const { list, totalCount } = data;
        const tmpList =
          list?.length > 0
            ? list.map((compInfo) => {
              return {
                ...compInfo,
              };
            })
            : [];

        if (tmpList.length < params.pageSize) {
          setNext(false);
        }

        if (isInit) {
          const companyList = [...companyListRes];
          companyList[curPage] = tmpList;
          const total = totalCount;
          setCompanyListRes(companyList);
          setTotal(total);
          setCurPage(curPage);
        } else {
          if (!companyListRes[curPage]) {
            const companyList = [...companyListRes];
            companyList[curPage] = tmpList;
            setCompanyListRes(companyList);
          }
          setCurPage(curPage);
          setTotal(totalCount);
        }
      });
  };
  const handlePageSize = (curPage) => {
    // const { companyListRes, getData, change } = this.store;
    setCurPage(curPage - 1);
    if (!companyListRes[curPage - 1]) {
      getData({
        curPage: curPage - 1,
      });
    }

    // if (!companyListRes[curPage]) {
    //   getData({
    //     curPage: curPage,
    //   });
    // }
  };
  const delFilterComps = useMemo(() => {
    const sortArr = [
      "热门企业",
      "新一代信息技术",
      "化工",
      "电力电气",
      "机械加工与制造",
      "新材料",
      "生物医药",
      "航空航天",
      "车船配套/汽车零部件",
      "新能源",
      "服务业",
      "造纸及纸品加工",
      "其他",
    ];
    const newFilterComps = filterComps.map((item) => {
      item.comps = item.comps.map((comp) => {
        return { compId: comp };
      });
      return item;
    });
    newFilterComps.forEach((item) => {
      let indx = sortArr.indexOf(item.name);
      sortArr[indx] = item;
    });
    return sortArr;
  }, []);
  useEffect(() => {
    setCompanyList(delFilterComps[0].comps);
    getData({ isInit: true, companyList: delFilterComps[0].comps });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getUrl = (url) => {
    return url.replace(
      /((https?)?\/\/image0.lietou-static.com\/img\/?)?(.*)$/,
      "//image0.lietou-static.com/img/$3"
    );
  };
  const compCardList = useMemo(() => {
    return companyListRes[curPage]?.length
      ? splitArray(5, companyListRes[curPage])
      : [];
  }, [companyListRes, curPage]);
  // console.log(total, compCardList);
  return (
    <div className="hot-comp-container-out2">
      <div className="hot-comp-container">
        <div className="comp-content">
          {total > 0 ? (
            <div className="comp-card-container">
              {compCardList.map((result, i) => {
                return (
                  <Row gutter={18} style={{ marginBottom: "10px",marginLeft: '0' }} key={i}>
                    {result.map((item, j) => {
                      return (
                        <div key={item.jobId} className="comp-card">
                            <a href={item.pcOuterLink}>
                              <div className="img-container">
                                <img src={getUrl(item.compLogo)} alt=""></img>
                              </div>
                            </a>
                            <div className="company-name-container">
                              <span className="company-name" title={item.title}>
                                {item.title}
                              </span>
                            </div>
                          </div>
                      );
                    })}
                  </Row>
                );
              })}
            </div>
          ) : (
            <div className="search-companyList-empty">
              这里没有更多啦，换个筛选条件试试吧
            </div>
          )}
          {total > 0 && total > 20 ? (
            <div className="search-pagination">
              <Pagination
                current={curPage + 1}
                total={total}
                showLessItems
                pageSize={20}
                onChange={handlePageSize}
                showSizeChanger={false}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
